import { ReservationInventoryItemGroupType } from "gen/ApiClient";

export const ReservationInventoryItemGroupTypesRecord: Record<ReservationInventoryItemGroupType, string> = {
    Ski: 'Ski',
    Snowboard: 'Snowboard',
    TourSki: 'Toer Ski'
}